import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  namespaced: true,
  state() {
    return {
      user: {
        id: localStorage.getItem("etqan_Dash_User_Id"),
        token: localStorage.getItem("etqan_Dash_Token"),
        usertype: localStorage.getItem("etqan_Dash_User_Type"),
        name: localStorage.getItem("etqan_Dash_User_name"),
        image: localStorage.getItem("etqan_Dash_userImg"),
        phone: localStorage.getItem("etqan_Dash_userPhone"),
        email: localStorage.getItem("etqan_Dash_userEmail"),
        gender: localStorage.getItem("etqan_Dash_userGender"),
      },
    };
  },
  mutations,
  actions,
  getters,
};
